import React from 'react';
import { useSecurityPolicy } from '../hooks/use-security-policy.js';
import SecurityPolicyPageView from './security-policy-page-view.jsx';

function SecurityPolicyPageContainer() {
  const state = useSecurityPolicy();

  return <SecurityPolicyPageView {...state} />;
}

export default SecurityPolicyPageContainer;
